<div class="lokos-breadcrumb">
    <div class="responsive-breadcrumb">
        <ng-container *ngFor="let item of breadcrumbs; let last = last;">
            <a *ngIf="!last || breadcrumbs.length === 1" [routerLink]="item.link" [queryParams]="item.queryParams">
                {{ item.label | translate }}
                <span *ngIf="!last">
                    <img src="../../../../../assets/images/arrowRightGray.svg" alt="">
                </span>
            </a>
            <a *ngIf="last && breadcrumbs.length > 1" class="last">
                {{ item.label | translate }}
            </a>
        </ng-container>
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</div>